import { createContext, useContext, useEffect, useState } from "react";

import { UrlContext } from "./UrlContext";
// import io from "socket.io-client";

export const ListDetailsContext = createContext();

export const ListDetailsProvider = ({ children }) => {
  const [tableData, setTableData] = useState([]);
  const [backupData, setBackupData] = useState([]);
  const [dataFetched, setDataFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fieldsLoading, setFieldsLoading] = useState(false);
  const [project, setProject] = useState([]);
  const [pageid, setPageID] = useState("");
  const { API_URL } = useContext(UrlContext);
  useEffect(() => {
    setLoading(true);
    if (pageid) {
      fetch(`${API_URL}list-details/${pageid}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((data) => {
          setTableData(data.tableData);
          setBackupData(data.tableData);
          setDataFetched(true);
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
      fetch(`${API_URL}list-title/${pageid}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((data) => {
          setProject(data.project);
        })
        .catch((err) => console.log(err));
    } else return;
  }, [pageid]);

  useEffect(() => {
    setFieldsLoading(true);
    setTimeout(() => setFieldsLoading(false), 20);
  }, [tableData]);

  return (
    <ListDetailsContext.Provider
      value={{
        tableData,
        backupData,
        setTableData,
        dataFetched,
        setPageID,
        loading,
        setLoading,
        project,
        setProject,
        fieldsLoading,
      }}
    >
      {children}
    </ListDetailsContext.Provider>
  );
};
